import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "jobs", label: "Jobs" },
  { id: "why-us", label: "Why Us" },
  { id: "industries", label: "Industries" },
  { id: "services", label: "Services" },
  { id: "resources", label: "Resources" },
  { id: "contact", label: "Contact" },
];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0A1128]/80 border-b border-white/10"
          : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="px-6 md:px-12 lg:px-24 h-[72px] flex items-center justify-between">
        <button
          onClick={() => scrollToSection("home")}
          className="flex items-center gap-3 group"
          data-testid="nav-logo"
        >
          <img src="/fam-logo.png" alt="FAM Job Consultancy" className="h-10 w-auto drop-shadow-lg" />
          <span className="hidden sm:block text-left leading-none">
            <span className="block font-display font-800 text-white text-sm font-bold tracking-wide">FAM JOB CONSULTANCY</span>
            <span className="block text-[10px] tracking-[0.25em] text-white/50 uppercase mt-0.5">Private Limited</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-links">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollToSection(l.id)}
              className="text-xs uppercase tracking-[0.2em] text-white/70 hover:text-white transition-colors duration-300"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollToSection("contact")}
            className="ml-2 bg-[#1D4ED8] hover:bg-[#1E3A8A] text-white text-xs uppercase tracking-[0.2em] px-6 py-3 transition-colors duration-300"
            data-testid="nav-cta-button"
          >
            Hire Talent
          </button>
        </nav>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A1128]/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => { setOpen(false); scrollToSection(l.id); }}
              className="text-left text-sm uppercase tracking-[0.2em] text-white/80"
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </motion.header>
  );
}
